module.exports = __webpack_public_path__ + "74983394d5b54e0d85d79bb6eb767a40.svg";